import { useCookies } from 'react-cookie';
import { useCallback } from 'react';
import { generateCartSessionHash } from './generateCartSessionHash';

export const useCartSession = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['cartSessionHash']);
  const cartSessionHashFromCookies = cookies['cartSessionHash'];

  const generateSessionHash = useCallback(() => {
    const applyCookie = (hash, expDate) => {
      setCookie('cartSessionHash', hash, {
        expires: expDate,
        path: '/',
      });
    };
    generateCartSessionHash(applyCookie);
  }, [setCookie]);

  const removeSessionHash = useCallback(() => {
    removeCookie('cartSessionHash');
  }, [removeCookie]);

  return { cartSessionHashFromCookies, generateSessionHash, removeSessionHash };
};
